<template>
  <div class="auditPage">
    <div>
      <div v-if="auditState===0">
        <img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/icon00.png"
          alt=""
        >
        <h2>重读申请已提交</h2>
        <span>老师们正在紧急审核中，{{rereadLastTime}}前处理，申请结果我们会以短信形式通知或在App中查看申请进度</span>
      </div>
      <div v-if="auditState===1">
        <img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/icon01.png"
          alt=""
        >
        <h2>重读申请审核中</h2>
        <span> 老师们正在紧急审核中，{{rereadLastTime}}前处理，申请结果我们会以短信形式通知或在App中查看申请进度</span>
      </div>
      <div v-if="auditState===2">
        <img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/icon02.png"
          alt=""
        >
        <h2>重读申请成功</h2>
        <span>重读申请成功，已为您开通
          <span
            v-for="(item,index) in openProductList"
            :key="index"
          > 《{{item.productName}}》</span> ，请前往学习中心学习吧，今年要努力呦，争取高分上岸~</span>

      </div>
      <div v-if="auditState===3">
        <img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/icon03.png"
          alt=""
        >
        <h2>重读申请失败</h2>
        <span><b>失败原因：</b>{{rejectReason}}</span>
        <div
          class="againAudit"
          v-if="auditStatusBtn&&rereadInfo.status!==3"
          @click="againBtn"
        >重新申请</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    auditState: {
      type: Number,
      default: 3,
    },
    auditStatusBtn: { // 重新申请btn：在重读申请结束时间的后10天内，该btn展示，超过时间隐藏，即结束时间是4.10，则4.20日后隐藏此btn
      type: Boolean,
      default: false,
    },
    openProductList: {
      type: Array,
      default: () => [],
    },
    rejectReason: String,
    rereadLastTime: String,
  },
  components: {

  },
  data() {
    return {
      rereadInfo: JSON.parse(sessionStorage.getItem('REREAD')) || null,
    };
  },

  computed: {},
  mounted() {
  },

  methods: {
    againBtn() {
      // 重新申请
      this.$emit('againReread');
    },

  },
  beforeDestroy() {
  },
};
</script>

<style lang="scss" scoped>
.auditPage {
  width: 100%;
  padding: 150px 82px 0 82px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  img {
    width: 368px;
    height: 217px;
  }
  h2 {
    font-size: 29px;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
    margin-bottom: 43px;
    margin-top: 46px;
  }
  span {
    display: block;
    font-size: 25px;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    b {
      font-size: 25px;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
    }
  }
  .againAudit {
    width: 236px;
    height: 80px;
    background: #ff7f41;
    border-radius: 41px;
    font-size: 29px;
    font-weight: 500;
    color: #ffffff;
    line-height: 80px;
    text-align: center;
    margin: 50px auto 0 auto;
  }
}
</style>
